// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "common" + "." + "b9f758bb1a09982ab28f" + ".js";
};